<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="startDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Start datum</label>
            <md-datepicker
              v-model="startDate"
              name="startDate"
              id="startDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="stopDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Stop datum</label>
            <md-datepicker
              v-model="stopDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <label>Geselecteerde routes</label>
        </md-field>
        <md-field v-for="(route, index) in this.routes" :key="index">
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="route_ids[route.id]" :disabled="requesting">{{
              route.name
            }}</md-checkbox>
          </div>
        </md-field>

        <md-field>
          <label>Geselecteerde dagen</label>
        </md-field>
        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="monday" :disabled="requesting"
              >Maandag</md-checkbox
            >
          </div>
        </md-field>

        <ValidationProvider
          v-if="monday"
          name="mondayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Maandag starttijd (00:00)</label>
            <md-input v-model="mondayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="monday"
          name="mondayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Maandag stoptijd (00:00)</label>
            <md-input v-model="mondayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="tuesday" :disabled="requesting"
              >Dinsdag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="tuesday"
          name="tuesdayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Dinsdag starttijd (00:00)</label>
            <md-input v-model="tuesdayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="tuesday"
          name="tuesdayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Dinsdag stoptijd (00:00)</label>
            <md-input v-model="tuesdayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="wednesday" :disabled="requesting"
              >Woensdag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="wednesday"
          name="wednesdayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Woensdag starttijd (00:00)</label>
            <md-input v-model="wednesdayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="wednesday"
          name="wednesdayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Woensdag stoptijd (00:00)</label>
            <md-input v-model="wednesdayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="thursday" :disabled="requesting"
              >Donderdag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="thursday"
          name="thursdayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Donderdag starttijd (00:00)</label>
            <md-input v-model="thursdayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="thursday"
          name="thursdayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Donderdag stoptijd (00:00)</label>
            <md-input v-model="thursdayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="friday" :disabled="requesting"
              >Vrijdag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="friday"
          name="fridayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Vrijdag starttijd (00:00)</label>
            <md-input v-model="fridayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="friday"
          name="fridayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Vrijdag stoptijd (00:00)</label>
            <md-input v-model="fridayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="saturday" :disabled="requesting"
              >Zaterdag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="saturday"
          name="saturdayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Zaterdag starttijd (00:00)</label>
            <md-input v-model="saturdayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="saturday"
          name="saturdayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Zaterdag stoptijd (00:00)</label>
            <md-input v-model="saturdayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="sunday" :disabled="requesting"
              >Zondag</md-checkbox
            >
          </div>
        </md-field>
        <ValidationProvider
          v-if="sunday"
          name="sundayStartTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Zondag starttijd (00:00)</label>
            <md-input v-model="sundayStartTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="sunday"
          name="sundayStopTime (00:00)"
          :rules="{
            required: false,
            regex: /^([0-1]{1}[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1})$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Zondag stoptijd (00:00)</label>
            <md-input v-model="sundayStopTime" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="submitButtonDisabled"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      startDate: null,
      stopDate: null,
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
      mondayStartTime: null,
      mondayStopTime: null,
      tuesdayStartTime: null,
      tuesdayStopTime: null,
      wednesdayStartTime: null,
      wednesdayStopTime: null,
      thursdayStartTime: null,
      thursdayStopTime: null,
      fridayStartTime: null,
      fridayStopTime: null,
      saturdayStartTime: null,
      saturdayStopTime: null,
      sundayStartTime: null,
      sundayStopTime: null,
      route_ids: {},
      routes: [],
      touched: {
        startDate: false,
        stopDate: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        mondayStartTime: false,
        mondayStopTime: false,
        tuesdayStartTime: false,
        tuesdayStopTime: false,
        wednesdayStartTime: false,
        wednesdayStopTime: false,
        thursdayStartTime: false,
        thursdayStopTime: false,
        fridayStartTime: false,
        fridayStopTime: false,
        saturdayStartTime: false,
        saturdayStopTime: false,
        sundayStartTime: false,
        sundayStopTime: false,
        route_ids: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];

      if (this.$route.params.id !== undefined) {
        this.loadShiftPeriod(this.$route.params.id);
      } else {
        this.startDate = null;
        this.stopDate = null;
        this.monday = 0;
        this.tuesday = 0;
        this.wednesday = 0;
        this.thursday = 0;
        this.friday = 0;
        this.saturday = 0;
        this.sunday = 0;

        setTimeout(this.resetTouched, 100);
      }
      this.loadRoutes();
    },
    validate() {
      var route_ids = [];

      for (var i in this.route_ids) {
        if (this.route_ids[i] != true) {
          continue;
        }

        route_ids.push(i);
      }

      this.requesting = true;
      this.$http
        .post(
          this.$apiBaseUrl +
            "shifts/period/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            shift_id: this.$route.params.shiftId,
            startDate: this.formatDateBack(this.startDate),
            stopDate: this.formatDateBack(this.stopDate),
            monday: this.monday ? 1 : 0,
            tuesday: this.tuesday ? 1 : 0,
            wednesday: this.wednesday ? 1 : 0,
            thursday: this.thursday ? 1 : 0,
            friday: this.friday ? 1 : 0,
            saturday: this.saturday ? 1 : 0,
            sunday: this.sunday ? 1 : 0,
            mondayStartTime: this.mondayStartTime ?? null,
            mondayStopTime: this.mondayStopTime ?? null,
            tuesdayStartTime: this.tuesdayStartTime ?? null,
            tuesdayStopTime: this.tuesdayStopTime ?? null,
            wednesdayStartTime: this.wednesdayStartTime ?? null,
            wednesdayStopTime: this.wednesdayStopTime ?? null,
            thursdayStartTime: this.thursdayStartTime ?? null,
            thursdayStopTime: this.thursdayStopTime ?? null,
            fridayStartTime: this.fridayStartTime ?? null,
            fridayStopTime: this.fridayStopTime ?? null,
            saturdayStartTime: this.saturdayStartTime ?? null,
            saturdayStopTime: this.saturdayStopTime ?? null,
            sundayStartTime: this.sundayStartTime ?? null,
            sundayStopTime: this.sundayStopTime ?? null,
            route_ids: route_ids
          })
        )
        .then(
          response => {
            this.requesting = false;
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Shift periode succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            this.requesting = false;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan shift",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    loadShiftPeriod(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "shifts/period/" + id).then(
        response => {
          this.startDate = this.formatDate(response.data.shiftPeriod.startDate);
          this.stopDate = this.formatDate(response.data.shiftPeriod.stopDate);
          this.monday = !!response.data.shiftPeriod.monday;
          this.tuesday = !!response.data.shiftPeriod.tuesday;
          this.wednesday = !!response.data.shiftPeriod.wednesday;
          this.thursday = !!response.data.shiftPeriod.thursday;
          this.friday = !!response.data.shiftPeriod.friday;
          this.saturday = !!response.data.shiftPeriod.saturday;
          this.sunday = !!response.data.shiftPeriod.sunday;

          this.mondayStartTime = response.data.shiftPeriod.mondayStartTime
            ? response.data.shiftPeriod.mondayStartTime.substring(0, 5)
            : null;
          this.mondayStopTime = response.data.shiftPeriod.mondayStopTime
            ? response.data.shiftPeriod.mondayStopTime.substring(0, 5)
            : null;
          this.tuesdayStartTime = response.data.shiftPeriod.tuesdayStartTime
            ? response.data.shiftPeriod.tuesdayStartTime.substring(0, 5)
            : null;
          this.tuesdayStopTime = response.data.shiftPeriod.tuesdayStopTime
            ? response.data.shiftPeriod.tuesdayStopTime.substring(0, 5)
            : null;
          this.wednesdayStartTime = response.data.shiftPeriod.wednesdayStartTime
            ? response.data.shiftPeriod.wednesdayStartTime.substring(0, 5)
            : null;
          this.wednesdayStopTime = response.data.shiftPeriod.wednesdayStopTime
            ? response.data.shiftPeriod.wednesdayStopTime.substring(0, 5)
            : null;
          this.thursdayStartTime = response.data.shiftPeriod.thursdayStartTime
            ? response.data.shiftPeriod.thursdayStartTime.substring(0, 5)
            : null;
          this.thursdayStopTime = response.data.shiftPeriod.thursdayStopTime
            ? response.data.shiftPeriod.thursdayStopTime.substring(0, 5)
            : null;
          this.fridayStartTime = response.data.shiftPeriod.fridayStartTime
            ? response.data.shiftPeriod.fridayStartTime.substring(0, 5)
            : null;
          this.fridayStopTime = response.data.shiftPeriod.fridayStopTime
            ? response.data.shiftPeriod.fridayStopTime.substring(0, 5)
            : null;
          this.saturdayStartTime = response.data.shiftPeriod.saturdayStartTime
            ? response.data.shiftPeriod.saturdayStartTime.substring(0, 5)
            : null;
          this.saturdayStopTime = response.data.shiftPeriod.saturdayStopTime
            ? response.data.shiftPeriod.saturdayStopTime.substring(0, 5)
            : null;
          this.sundayStartTime = response.data.shiftPeriod.sundayStartTime
            ? response.data.shiftPeriod.sundayStartTime.substring(0, 5)
            : null;
          this.sundayStopTime = response.data.shiftPeriod.sundayStopTime
            ? response.data.shiftPeriod.sundayStopTime.substring(0, 5)
            : null;

          var route_ids = {};

          for (var i in response.data.shiftPeriod.route_ids) {
            route_ids[response.data.shiftPeriod.route_ids[i]] = true;
          }

          this.route_ids = route_ids;

          setTimeout(this.resetTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van shifts", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutes() {
      if (this.$route.params.shiftId === undefined) {
        return;
      }

      this.requesting = true;
      this.$http
        .get(
          this.$apiBaseUrl + "shifts/" + this.$route.params.shiftId + "/routes"
        )
        .then(
          response => {
            this.routes = response.data.routes;

            this.requesting = false;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van diensten", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    resetTouched() {
      this.touched.startDate = false;
      this.touched.stopDate = false;
      this.touched.monday = false;
      this.touched.tuesday = false;
      this.touched.wednesday = false;
      this.touched.thursday = false;
      this.touched.friday = false;
      this.touched.saturday = false;
      this.touched.sunday = false;
      this.touched.mondayStartTime = false;
      this.touched.mondayStopTime = false;
      this.touched.tuesdayStartTime = false;
      this.touched.tuesdayStopTime = false;
      this.touched.wednesdayStartTime = false;
      this.touched.wednesdayStopTime = false;
      this.touched.thursdayStartTime = false;
      this.touched.thursdayStopTime = false;
      this.touched.fridayStartTime = false;
      this.touched.fridayStopTime = false;
      this.touched.saturdayStartTime = false;
      this.touched.saturdayStopTime = false;
      this.touched.sundayStartTime = false;
      this.touched.sundayStopTime = false;
      this.touched.route_ids = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    startDate() {
      if (!this.requesting) {
        this.touched.startDate = true;
      }
    },
    stopDate() {
      if (!this.requesting) {
        this.touched.stopDate = true;
      }
    },
    monday() {
      if (!this.requesting) {
        this.touched.monday = true;
      }
    },
    tuesday() {
      if (!this.requesting) {
        this.touched.tuesday = true;
      }
    },
    wednesday() {
      if (!this.requesting) {
        this.touched.wednesday = true;
      }
    },
    thursday() {
      if (!this.requesting) {
        this.touched.thursday = true;
      }
    },
    friday() {
      if (!this.requesting) {
        this.touched.friday = true;
      }
    },
    saturday() {
      if (!this.requesting) {
        this.touched.saturday = true;
      }
    },
    sunday() {
      if (!this.requesting) {
        this.touched.sunday = true;
      }
    },
    mondayStartTime() {
      if (!this.requesting) {
        this.touched.mondayStartTime = true;
      }
    },
    mondayStopTime() {
      if (!this.requesting) {
        this.touched.mondayStopTime = true;
      }
    },
    tuesdayStartTime() {
      if (!this.requesting) {
        this.touched.tuesdayStartTime = true;
      }
    },
    tuesdayStopTime() {
      if (!this.requesting) {
        this.touched.tuesdayStopTime = true;
      }
    },
    wednesdayStartTime() {
      if (!this.requesting) {
        this.touched.wednesdayStartTime = true;
      }
    },
    wednesdayStopTime() {
      if (!this.requesting) {
        this.touched.wednesdayStopTime = true;
      }
    },
    thursdayStartTime() {
      if (!this.requesting) {
        this.touched.thursdayStartTime = true;
      }
    },
    thursdayStopTime() {
      if (!this.requesting) {
        this.touched.thursdayStopTime = true;
      }
    },
    fridayStartTime() {
      if (!this.requesting) {
        this.touched.fridayStartTime = true;
      }
    },
    fridayStopTime() {
      if (!this.requesting) {
        this.touched.fridayStopTime = true;
      }
    },
    saturdayStartTime() {
      if (!this.requesting) {
        this.touched.saturdayStartTime = true;
      }
    },
    saturdayStopTime() {
      if (!this.requesting) {
        this.touched.saturdayStopTime = true;
      }
    },
    sundayStartTime() {
      if (!this.requesting) {
        this.touched.sundayStartTime = true;
      }
    },
    sundayStopTime() {
      if (!this.requesting) {
        this.touched.sundayStopTime = true;
      }
    },

    route_ids: {
      handler: function(val, oldVal) {
        this.touched.route_ids = true;
      },
      deep: true
    },

    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Shift periode bewerken";
      }
      return "Dienst periode toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "departure_board";
      }
      return "departure_board";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    submitButtonDisabled: function() {
      if (this.requesting === true || this.formTouched === false) {
        return true;
      }

      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;
  &:after {
    bottom: 20px;
  }
}
</style>
<style lang="scss">
.md-inline-checkboxes .md-checkbox .md-checkbox-label {
  line-height: 6px !important;
}
</style>
